import { CUSTOMER_TIERS, FEATURES } from '../utils/consts';

export const MIXPANEL_UPGRADE_ACCOUNT = 'Upgrade Account Click';
export const MIXPANEL_PAY_NOW_CLICK = 'Pay Now Click';
export const MIXPANEL_PAGE_LOADED = 'Page Loaded';
export const MIXPANEL_FEATURES_CONTACT_CLICK = 'Features Contact Click';

export const DATA_TEST_ID_TIMEZONE = 'datapair-timezone';
export const DATA_TEST_ID_CURRENCY = 'datapair-currency';
export const DATA_TEST_ID_START_DATE = 'datapair-start-date';
export const DATA_TEST_ID_END_DATE = 'datapair-end-date';
export const DATA_TEST_ID_NO_ACTIVE_PLAN = 'no-active-plan';
export const DATA_TEST_ID_PRICING_CARDS = 'pricing-cards';
export const DATA_TEST_ID_ORG_PLAN_PROGRESS = 'org-plan-progress';
export const DATA_TEST_ID_ORG_PLAN_DETAILS = 'org-plan-details';
export const DATA_TEST_ID_ACTIVE_TIER_FOOTER = 'active-tier-footer';

export const DATA_BADGE_TIER_FREE = 'badge-tier-free';
export const DATA_BADGE_TIER_STANDARD_UNIFIED = 'badge-tier-standard';
export const DATA_BADGE_TIER_ENTERPRISE = 'badge-tier-enterprise';

export const DATA_BADGE_MAP = {
    [CUSTOMER_TIERS.FREE]: DATA_BADGE_TIER_FREE,
    [CUSTOMER_TIERS.STANDARD_UNIFIED]: DATA_BADGE_TIER_STANDARD_UNIFIED,
    [CUSTOMER_TIERS.ENTERPRISE]: DATA_BADGE_TIER_ENTERPRISE,
};
export const DATA_TEST_ID_CAP = 'cap';
export const DATA_TEST_ID_AD_SPEND_CAP = 'ad-spend';
export const CHECKOUT_URL = 'react/plan-upgrade';

export const PACING_TYPES = {
    CONVERSIONS: 'conversions',
    AD_SPEND: 'spend',
};

export const ABOUT_TO_EXPIRE_DAYS = 45;

export const isExpired = expiresInDays => expiresInDays <= 0;

export const isAboutToExpire = expireInDays => expireInDays <= ABOUT_TO_EXPIRE_DAYS && expireInDays > 0;

const LOW_USAGE_PERCENT_NON_FREE_TIER = 85;
const HIGH_USAGE_PERCENT_NON_FREE_TIER = 95;
const LOW_USAGE_PERCENT_FREE_TIER = 50;
const HIGH_USAGE_PERCENT_FREE_TIER = 75;

export const isNoUsage = usageInPercent => usageInPercent === 0;
export const isLowUsage = (usageInPercent, isFreeTier) =>
    usageInPercent < (isFreeTier ? LOW_USAGE_PERCENT_FREE_TIER : LOW_USAGE_PERCENT_NON_FREE_TIER);
export const isHighUsage = (usageInPercent, isFreeTier) =>
    usageInPercent >= (isFreeTier ? LOW_USAGE_PERCENT_FREE_TIER : LOW_USAGE_PERCENT_NON_FREE_TIER) &&
    usageInPercent < (isFreeTier ? HIGH_USAGE_PERCENT_FREE_TIER : HIGH_USAGE_PERCENT_NON_FREE_TIER);
export const isAboutToMaxCap = (usageInPercent, isFreeTier) =>
    usageInPercent >= (isFreeTier ? HIGH_USAGE_PERCENT_FREE_TIER : HIGH_USAGE_PERCENT_NON_FREE_TIER) &&
    usageInPercent < 100;
export const isCapMaxed = usageInPercent => usageInPercent >= 100;

export const TIER_CARD_COLORS = {
    [CUSTOMER_TIERS.FREE]: 'var(--turquoise100)',
    [CUSTOMER_TIERS.STANDARD_UNIFIED]: 'var(--blue300)',
    [CUSTOMER_TIERS.ENTERPRISE]: 'var(--indigo)',
};

export const WARNING_TYPES = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    EXTERNAL_LINK: 'externalLink',
    INFO: 'info',
    WHITE_INFO: 'whiteInfo',
};

export const ARR_CURRENCY = 'USD';

export const ALERT_LEVELS = {
    NONE: 0,
    GENTLE_WARNING: 1,
    MODERATE_WARNING: 2,
    HARSH_WARNING: 3,
    BLOCKED: 4,
};

export const HARSH_ALERT_LEVELS = [ALERT_LEVELS.HARSH_WARNING, ALERT_LEVELS.BLOCKED];

export const CAP_TYPES = {
    EVENT: 'event',
    CLICK: 'click',
    IMPRESSION: 'impression',
};

export const CAP_DISPLAY_NAMES = {
    [CAP_TYPES.EVENT]: 'STATIC.PAGES.ACCOUNT_PLAN.ALERTS.METRIC_EVENT',
    [CAP_TYPES.CLICK]: 'STATIC.PAGES.ACCOUNT_PLAN.ALERTS.METRIC_CLICK',
    [CAP_TYPES.IMPRESSION]: 'STATIC.PAGES.ACCOUNT_PLAN.ALERTS.METRIC_IMPRESSION',
};

export const PACING_WARNING_MESSAGES = {
    noUsage: 'STATIC.PAGES.ACCOUNT_PLAN.PACING_CARD.INFORMATION.NO_USAGE',
    usage: 'STATIC.PAGES.ACCOUNT_PLAN.PACING_CARD.INFORMATION.USAGE',
    maxed: 'STATIC.PAGES.ACCOUNT_PLAN.PACING_CARD.INFORMATION.MAXED_CAP',
    expiring: 'STATIC.PAGES.ACCOUNT_PLAN.PACING_CARD.INFORMATION.DATE_EXPIRED',
    expired: 'STATIC.PAGES.ACCOUNT_PLAN.PACING_CARD.INFORMATION.EXPIRED',
};

export const PACING_IDS = {
    WEB: 'web',
    MOBILE: 'mobile',
    PC_CONSOLE: 'pc_console',
    AD_SPEND: 'ad_spend',
};


export const FEATURE_TYPE = {
    ADD_ONS: 'add-ons',
    ADVANCED_COLLECT: 'advanced-collect',
};

export const FEATURE_STATUS = {
    AVAILABLE: 'available',
    TRIAL: 'trial',
    CONTRACTED: 'contracted',
};

const INCLUDED_FEATURE_CONFIG = {
    TITLE_COLOR: 'var(--gray800)',
    FEATURE_ICON_COLOR: 'var(--gray700)',
    STATUS_ICON_COLOR: 'var(--green300)',
    BACKGROUND_COLOR: 'var(--green100)',
};

export const FEATURE_STATUS_CONFIG = {
    [FEATURE_STATUS.CONTRACTED]: {
        ORDER: 0,
        ...INCLUDED_FEATURE_CONFIG,
    },
    [FEATURE_STATUS.TRIAL]: {
        ORDER: 1,
        ...INCLUDED_FEATURE_CONFIG,
    },
    [FEATURE_STATUS.AVAILABLE]: {
        ORDER: 2,
        TITLE_COLOR: 'var(--gray600)',
        FEATURE_ICON_COLOR: 'var(--gray500)',
        STATUS_ICON_COLOR: 'var(--gray500)',
        BACKGROUND_COLOR: 'var(--gray150)',
    },
};

export const getFeatureStatus = feature => {
    if (feature?.value) {
        if (feature.meta?.is_contracted) {
            return FEATURE_STATUS.CONTRACTED;
        }
        return FEATURE_STATUS.TRIAL;
    }

    return FEATURE_STATUS.AVAILABLE;
};

const getCombinedStatus = (allFeaturesDict, featureNames) => {
    const featureStatuses = featureNames.map(featureName => getFeatureStatus(allFeaturesDict[featureName]));

    if (featureStatuses.some(status => status === FEATURE_STATUS.TRIAL)) {
        return FEATURE_STATUS.TRIAL;
    }
    if (featureStatuses.some(status => status === FEATURE_STATUS.CONTRACTED)) {
        return FEATURE_STATUS.CONTRACTED;
    }
    return FEATURE_STATUS.AVAILABLE;
};

const getCombinedTextReplace = (allFeaturesDict, featureTitleDict, defaultTitle) => {
    const infoSections = [];
    const featuresDict = Object.fromEntries(
        Object.entries(featureTitleDict)
            .map(([featureName]) => [featureName, allFeaturesDict[featureName]])
            .filter(([, feature]) => feature)
    );

    if (Object.values(featuresDict).every(({ value }) => !value)) {
        infoSections.push(defaultTitle);
    } else {
        Object.entries(featuresDict).forEach(([featureName, { value }]) => {
            if (value) {
                infoSections.push(featureTitleDict[featureName]);
            }
        });
    }

    return {
        info: infoSections
            .map((section, index) => (index === 0 ? `${section.charAt(0).toUpperCase()}${section.slice(1)}` : section))
            .join('+'),
    };
};

export const FEATURE_CONFIG = [
    {
        name: FEATURES.AUDIENCES,
        iconName: 'users',
        learnMoreLink: 'https://support.singular.net/hc/en-us/articles/360025454492-Audiences-FAQ',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: (_, isUnified) => isUnified,
        getStatus: allFeaturesDict =>
            getCombinedStatus(allFeaturesDict, [FEATURES.AUDIENCES, FEATURES.AUDIENCES_AND_INCREMENTALITY]),
        renderTextReplace: allFeaturesDict =>
            getCombinedTextReplace(
                allFeaturesDict,
                {
                    [FEATURES.AUDIENCES]: 'Audiences',
                    [FEATURES.AUDIENCES_AND_INCREMENTALITY]: 'Incrementality',
                },
                'Audiences'
            ),
    },
    {
        name: FEATURES.CREATIVE_IQ,
        iconName: 'photo-spark',
        learnMoreLink: 'https://support.singular.net/hc/en-us/articles/43756881255451-Creative-Gallery-FAQ',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: () => true,
    },
    {
        name: FEATURES.GLOBAL_PROPERTIES_AGGREGATION,
        iconName: 'settings-plus',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: (allFeaturesDict, isUnified) =>
            isUnified && allFeaturesDict[FEATURES.GLOBAL_PROPERTIES_AGGREGATION]?.value,
    },
    {
        name: FEATURES.CROSS_DEVICE_ATTRIBUTION,
        iconName: 'devices',
        learnMoreLink: 'https://support.singular.net/hc/en-us/articles/360041518132-Cross-Device-Attribution-FAQ',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: (allFeaturesDict, isUnified) => {
            if (!isUnified) return false;

            const attributionFeatures = [
                allFeaturesDict[FEATURES.WEB_ATTRIBUTION],
                allFeaturesDict[FEATURES.MOBILE_ATTRIBUTION],
                allFeaturesDict[FEATURES.PC_CONSOLE_ATTRIBUTION],
            ];
            return attributionFeatures.filter(feature => feature?.value).length >= 2;
        },
    },
    {
        name: FEATURES.AD_REVENUE_ANALYTICS,
        iconName: 'ad',
        learnMoreLink: 'https://support.singular.net/hc/en-us/articles/360022067552-Ad-Monetization-Analytics-FAQ',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: () => true,
    },
    {
        name: FEATURES.ETL_UL_EVENTS,
        iconName: 'database',
        learnMoreLink:
            'https://support.singular.net/hc/en-us/articles/360048784092-Data-Destinations-User-Level-Event-Level-Data-Schemas',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: (_, isUnified) => isUnified,
    },
    {
        name: FEATURES.MULTIPLE_ATTRIBUTION_TYPES,
        iconName: 'chart-cohort',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: (allFeaturesDict, isUnified) =>
            isUnified && allFeaturesDict[FEATURES.MULTIPLE_ATTRIBUTION_TYPES]?.value,
    },
    {
        name: FEATURES.BANNERS,
        iconName: 'profile-line',
        learnMoreLink: 'https://support.singular.net/hc/en-us/articles/11032086884123-Singular-Banners-FAQ',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: (_, isUnified) => isUnified,
    },
    {
        name: FEATURES.ETL_AGGREGATED,
        iconName: 'database',
        learnMoreLink:
            'https://support.singular.net/hc/en-us/articles/360039511492-Data-Destinations-Aggregated-Data-Schemas',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: () => true,
    },
    {
        name: FEATURES.GOVERNANCE,
        iconName: 'subtask',
        learnMoreLink:
            'https://support.singular.net/hc/en-us/articles/360059060891-How-to-Create-Governance-Taxonomy-Schemas',
        type: FEATURE_TYPE.ADD_ONS,
        isVisible: () => true,
    },
    {
        name: FEATURES.MULTIPLE_PULLS,
        type: FEATURE_TYPE.ADVANCED_COLLECT,
        isVisible: () => true,
    },
    {
        name: FEATURES.MULTIPLE_BREAKDOWNS,
        type: FEATURE_TYPE.ADVANCED_COLLECT,
        isVisible: () => true,
    },
    {
        name: FEATURES.MORE_AGGREGATED_EVENT_SLOTS,
        type: FEATURE_TYPE.ADVANCED_COLLECT,
        isVisible: () => true,
    },
    {
        name: FEATURES.MORE_COHORT_PERIODS,
        type: FEATURE_TYPE.ADVANCED_COLLECT,
        isVisible: () => true,
    },
];
